import { render } from "./BankIdForm.vue?vue&type=template&id=611054ed"
import script from "./BankIdForm.vue?vue&type=script&lang=js"
export * from "./BankIdForm.vue?vue&type=script&lang=js"

import "./BankIdForm.vue?vue&type=style&index=0&id=611054ed&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__